import { Helmet } from 'react-helmet-async';
// sections
import { PlaylistView } from 'src/sections/playlist/view';

// ----------------------------------------------------------------------

export default function OverviewAppPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Playlist</title>
      </Helmet>

      <PlaylistView />
    </>
  );
}
